import { Schema } from '../create/components/team-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { TeamForm } from '../create/components/team-form';
import { useUpdateTeamMutation } from '../mutations';
import { useParams } from '~/hooks/useParams';
import { teamIdParamSchema } from '~/schemas';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { useTeamsQuery } from '../queries';
import { toast } from 'react-toastify';

export function Page() {
  const { teamId } = useParams(teamIdParamSchema.parse);
  const { data } = useTeamsQuery(teamId);
  const mutation = useUpdateTeamMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(mutation.mutateAsync({ id: teamId, payload }), {
      success: 'Laget har uppdaterats',
      pending: 'Uppdaterar laget...',
    });
    navigate(-1);
  }

  if (!data) return false;

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera lag" />

      <PageLayout.Section>
        <TeamForm
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
          mode="edit"
          defaultValues={{
            name: data?.name ?? '',
            club: [data?.club.name ?? '', data?.club.id ?? 0],
            division: [data?.division.name ?? '', data?.division.id ?? 0],
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
}
